const flexCenter = {
  display: 'flex',
  alignItems: 'center',
} as const

const flexColumn = {
  display: 'flex',
  flexDirection: 'column',
} as const

const iconBase = {
  color: 'gray.64',
} as const

export const styles = {
  dialogContent: {
    ...flexColumn,
    padding: 0,
  },

  headerContainer: {
    ...flexColumn,
    gap: 2,
    py: 3,
    px: 4,
  },

  clientInfo: {
    ...flexCenter,
    gap: 2,
  },

  clientAvatar: {
    width: 20,
    height: 20,
    padding: 2,
    fontSize: 12,
  },

  divider: {
    height: 8,
    backgroundColor: 'gray.3',
    border: 'none',
    borderTop: '1px solid',
    borderColor: 'gray.12',
  },

  formRow: {
    py: 1.5,
    px: 4,
    height: '100%',
  },

  formContainer: {
    ...flexColumn,
    height: '100%',
  },

  calendarIcon: {
    ...iconBase,
    fontSize: 16,
  },

  dateRow: {
    ...flexCenter,
    gap: 2,
    py: 1.5,
    px: 4,
  },

  contentEditor: {
    height: '100%',
    width: '100%',
    '& .MuiFormControl-root, .MuiBox-root': {
      height: '100%',

      '& .tox-tinymce': {
        height: '100% !important',
      },
    },
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
} as const
